import { render, staticRenderFns } from "./serviescon.vue?vue&type=template&id=2d33a9bc&scoped=true"
import script from "./serviescon.vue?vue&type=script&lang=js"
export * from "./serviescon.vue?vue&type=script&lang=js"
import style0 from "./serviescon.vue?vue&type=style&index=0&id=2d33a9bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d33a9bc",
  null
  
)

export default component.exports